var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContextMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1427 -743)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 19,
    cy: 19,
    r: 19,
    transform: "translate(1427 743)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(682 2208) rotate(-90)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(1443 752)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(1443 761)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(1443 770)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContextMenuIcon);
export default __webpack_public_path__ + "static/media/context-menu-icon.f315fc80.svg";
export { ForwardRef as ReactComponent };